import { upperFirst, words } from "lodash";
export const ucwords = (value) => {
    if (value) {
        return words(value.replace(new RegExp('_', 'g'), ' ')).map(item => {
            return upperFirst(item);
        }).join(' ');
    }
    return '';
};
